import React, { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { EaseTable } from '../../../libs/EaseTable';
import { ContentCard, ContactModal, TransferWizard, BulkUploadModal, PaginationKaBaap } from '../../Common';
import { getContactsTableColumns, contactsTableFilterNodes } from './constants';
import { alertify, handleApiExceptions, generate_query_set, goTo } from '../../../app_methods';
import { Contact, Beneficiary } from '../../../models';
import { Menu, Dropdown, Icon } from 'antd';
import { BeneficiariesDrawer } from '../BeneficiariesDrawer';
import { connect } from 'react-redux';
import { updateCurrentUserAction } from '../../../redux/actions';
import { CreatePermissionHoc, PermissionHoc } from '../../HOC';

const ContactList = (props) => {
    const [contacts, setContacts] = useState([]);
    const [activeContact, setActiveContact] = useState({});
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [pagination, setPagination] = useState({
        pageSize: 15,
        current: 1,
        hasNext: true,
        showing: { from: 1, to: 15 }
    });
    const [filters, setFilters] = useState({});
    const [showContactModal, setShowContactModal] = useState(false);
    const [showBeneficiariesDrawer, setShowBeneficiariesDrawer] = useState(false);
    const [showTransferWizard, setShowTransferWizard] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);


    const fetchContacts = async (_pagination, _filters) => {
        if (!props.current_user.key) return;
        setIsTableLoading(true);
        const response = await Contact.list_v2({ ...{ pageSize: _pagination.pageSize, current: _pagination.current }, ..._filters });
        if (!response.success) {
            setIsTableLoading(false);
            handleApiExceptions(response);
            return;
        }
        // let contacts = generate_query_set(Contact, response.data.results)
        // contacts = contacts.map((contact) => { return { ...contact, is_submerchant:!!_filters.submerchant_id }})
        // setContacts(contacts);
        setContacts(generate_query_set(Contact, response.data.results));
        setPagination({  ..._pagination, ...response.data.pagination  });
        setIsTableLoading(false);
    };

    const downloadReport = async () => {
        setIsDownloading(true);
        const response = await Beneficiary.download_report({ ...filters });
        if (!response.success) {
            setIsDownloading(false);
            handleApiExceptions(response);
            return;
        }
        alertify(
            "Success",
            response?.data?.message || "Request generated Successfully",
            "confirm",
            {
                closable: true,
                cancelText: "Close",
                okText: "Go to Report Section",
                onOk: () => goTo(`/reports`, props.history),
                onCancel: () => { },
                icon: <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
            }
        );
        setIsDownloading(false);
    };

    const saveContact = async (values) => {
        setIsSaving(true);
        const contact = new Contact(values);
        const response = await contact.save();
        if (!response.success) {
            setIsSaving(false);
            handleApiExceptions(response);
            return;
        }
        toggleContactModal();
        alertify(
            "Success",
            `Contact ${activeContact.is_edit ? "updated" : "created"} successfully.`,
            "success",
            {
                cancelText: "Close",
                okText: activeContact.is_edit ? "Ok" : "Create Beneficiary",
                onOk: () => activeContact.is_edit ? null : toggleBeneficiariesDrawer(response.data.contact)
            }
        );
        setIsSaving(false);
        fetchContacts(pagination, filters);
    };

    const toggleContactModal = (contact = {}) => {
        setActiveContact(contact);
        setShowContactModal(!showContactModal);
    };

    const toggleBeneficiariesDrawer = (contact = {}) => {
        setActiveContact(contact);
        setShowBeneficiariesDrawer(!showBeneficiariesDrawer);
    };

    const toggleTransferWizard = () => {
        setShowTransferWizard(!showTransferWizard);
    };

    const toggleBulkUploadModal = () => {
        setShowBulkUploadModal(!showBulkUploadModal);
    };

    const handleTableChange = (tableInfo) => {
        if (tableInfo.trigger == "columns") return;
        let _pagination = tableInfo.pagination;
        if (tableInfo.trigger == "filters") _pagination.current = 1;
        setPagination(_pagination);
        setFilters(tableInfo.filters);
        fetchContacts(_pagination, tableInfo.filters);
    };

    const onPageChange = (_pagination) => {
        setPagination({ ..._pagination });
        fetchContacts({ ..._pagination }, filters);
    };

    const CreateButton = CreatePermissionHoc({ create_permission: 'CONTACTS_WRITE', bulk_permission: 'BENEFICIARIES_BULK_UPLOAD' }, { onCreateClick: toggleContactModal, onBulkClick: toggleBulkUploadModal, createText: <><Icon type="plus" /> New Contact </>, bulkText: "Bulk Upload" });
    const tableColumns = getContactsTableColumns({ toggleContactModal, toggleBeneficiariesDrawer });
    // const filterNodes = contactsTableFilterNodes(props.current_user);
    const filterNodes = contactsTableFilterNodes;


    useEffect(() => {
        props.onChildMount();
        fetchContacts({ ...pagination }, { ...filters });
    }, []);

    return (
        <ContentCard className="p-3">
            <div className="w-100 d-flex justify-content-end">
                <CreateButton />
            </div>
            <EaseTable
                rowKey="uuid"
                loading={isTableLoading}
                data={contacts}
                columns={tableColumns}
                fixedSelectable={!isMobile}
                handleTableChange={handleTableChange}
                // pagination={pagination}
                // totalRecords={pagination.total}
                filterNodes={filterNodes}
                downloadable={true}
                onDownload={downloadReport}
                isDownloading={isDownloading}
            /><PaginationKaBaap pageChange={onPageChange} pagination={pagination} />
            <ContactModal
                visible={showContactModal}
                toggleContactModal={toggleContactModal}
                contact={activeContact}
                saveContact={saveContact}
                loading={isSaving}
            />
            <BeneficiariesDrawer
                visible={showBeneficiariesDrawer}
                toggleBeneficiariesDrawer={toggleBeneficiariesDrawer}
                contact={activeContact}
            />
            <TransferWizard
                visible={showTransferWizard}
                toggleTransferWizard={toggleTransferWizard}
            />
            <BulkUploadModal
                history={props.history}
                visible={showBulkUploadModal}
                toggleBulkUploadModal={toggleBulkUploadModal}
                onSuccess={() => fetchContacts(pagination, filters)}
                type="beneficiary"
            />
        </ContentCard>
    );
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

const mapDispatchToProps = dispatch => ({
    updateCurrentUser: user => dispatch(updateCurrentUserAction(user))
});

export default connect(mapStateToProps, mapDispatchToProps)(PermissionHoc(ContactList, 'CONTACTS_READ'));